import {
  isBrowser,
  createCookie,
  getCookie,
  deleteCookie,
  getAllUrlParams,
  loadScriptHead,
  setPreviousUrl,
} from "@helpers/browser";
import { hashEmail } from "@helpers/general";
import { getPageViewTrackings } from "./src/context/Tracking";
import "./src/styles/global.css";

export const onInitialClientRender = () => {
  window.__isHydrated = true;

  // AppLovin - Pixel implementation
  // Check if the `_axwrt` cookie exists
  const axwrtValue = getCookie("_axwrt");

  if (axwrtValue) {
    // Set the `axwrt` cookie if it doesn't already exist
    if (!getCookie("axwrt")) {
      document.cookie = `axwrt=${axwrtValue}; Expires=${new Date(
        Date.now() + 365 * 24 * 60 * 60 * 1000 // 1 year expiration
      ).toUTCString()}; Domain=.analuisa.com; Path=/; SameSite=Lax`;
      console.log("axwrt cookie has been set");
    }
  }
};

export const onClientEntry = () => {
  window.ElevarDataLayer = window.ElevarDataLayer ?? [];
};

export const onPreRouteUpdate = ({ location, prevLocation }) => {
  setPreviousUrl(prevLocation);

  const paramsURL = getAllUrlParams(location?.href);
  if (paramsURL?.irclickid) {
    // Store irclickid in cookies for 30 days (+ update cookie)
    createCookie("_irclickid", paramsURL?.irclickid, 30);
  }
};

/**
 * Do not run actionFun until conditionFun returns true
 * @param {*} actionFun
 * @param {*} conditionFun
 */
function runUntil(actionFun, conditionFun) {
  if (conditionFun()) {
    actionFun();
  } else {
    setTimeout(() => {
      runUntil(actionFun, conditionFun);
    }, 100);
  }
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  // This is needed after we switch to Gatsby Script to load script.
  // We need to make sure everything is ready before calling these
  // analytics functions.

  runUntil(
    () => {
      if (window.ElevarInvalidateContext) {
        window.ElevarInvalidateContext?.();
      }
    },
    () => window.ElevarInvalidateContext
  );

  getPageViewTrackings().forEach((trackingPageView) =>
    runUntil(
      () => {},
      () => trackingPageView()
    )
  );

  runUntil(
    () => {
      loadScriptHead("https://utt.impactcdn.com/A3670505-08a4-4003-a105-fc58ad27da3c1.js").then(
        async () => {
          try {
            const exponeaEmail = isBrowser && window.exponea?.email_id;
            const email =
              exponeaEmail && exponeaEmail !== "null" && exponeaEmail !== "false"
                ? await hashEmail(exponeaEmail)
                : "";
            const data = email
              ? { customerId: email, customerEmail: email }
              : { customerId: "", customerEmail: "" };

            window.ire("identify", data);
          } catch (err) {
            console.error("Impact identify failed", err);
          }
        }
      );
    },
    () => window?.exponea
  );

  if (
    ((!prevLocation || prevLocation?.pathname?.includes("/collections/")) &&
      !location?.pathname?.includes("/products/")) ||
    location?.search?.includes("?origin_content=")
  ) {
    // Remove cookies path
    deleteCookie("bread_url");
    deleteCookie("bread_title");
  }

  if (
    (location.pathname.includes("/products/") ||
      location.pathname.includes("/p/") ||
      location.pathname.includes("/collections/")) &&
    !window.bvScriptLoaded
  ) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `https://apps.bazaarvoice.com/deployments/analuisa/main_site/${process.env.GATSBY_BAZAARVOICE_ENV}/en_US/bv.js`;
    script.onload = () => {
      window.bvScriptLoaded = true;
    };
    script.onerror = () => {
      console.error("Error loading Bazaarvoice script");
    };
    document.head.appendChild(script);
  }
};
